var map = {
	"./burger-icon.svg": "6742",
	"./captcha.svg": "cac4",
	"./captcha_magento.svg": "cca8",
	"./check-icon.svg": "fdfe",
	"./circle.svg": "b289",
	"./close-icon.svg": "3e79",
	"./close-modal-menu.svg": "5176",
	"./close-modal.svg": "c09e",
	"./cloud.svg": "2b35",
	"./clutch.svg": "9000",
	"./code-quality-icon.svg": "ba88",
	"./code-review-icon.svg": "7011",
	"./code-security-icon.svg": "41b4",
	"./collapse-down.svg": "5011",
	"./delete.svg": "0d45",
	"./delete_magento.svg": "5d84",
	"./design-architecture-icon.svg": "f173",
	"./icon-ai.svg": "71e3",
	"./icon-ecommerce.svg": "d478",
	"./icon-recruitment.svg": "7b7c",
	"./icon-web.svg": "9fed",
	"./linkedin.svg": "9ed9",
	"./logo-ai.svg": "8cfa",
	"./logo-ecommerce.svg": "a376",
	"./logo-magento.svg": "c545",
	"./logo-web.svg": "c879",
	"./logo.svg": "5b1c",
	"./magento-logo.svg": "8d89",
	"./maintainability-icon.svg": "42a5",
	"./next-arrow.svg": "73f4",
	"./play.svg": "dab1",
	"./prev-arrow.svg": "a0d5",
	"./range.svg": "8734",
	"./range_magento.svg": "6e97",
	"./rarr-icon.svg": "91eb",
	"./scalability-icon.svg": "57a7",
	"./search-icon.svg": "7669",
	"./security-check-icon.svg": "e1db",
	"./skype.svg": "0e53",
	"./telegram.svg": "2b29",
	"./ukraine-01.svg": "9f68",
	"./ukraine-02.svg": "54a2",
	"./version-icon.svg": "c683",
	"./white/clutch.svg": "7b26",
	"./white/linkedin.svg": "d25a",
	"./white/next.svg": "c133",
	"./white/prev.svg": "5389",
	"./white/skype.svg": "074c",
	"./white/telegram.svg": "350a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";